<style src="css/my.css" scoped></style>
<template>
    <div  class="topBg">
        <div class="topBtn">
            <div class="signOut" @click="signOut" v-if="companyId!='10015'"></div>
            <div class="news" @click="to(`news`)">
                <div class="num" v-if="count>0">{{count}}</div>
            </div>
        </div>
        <div>
            <div class="userBox">
                <div class="userImgBox">
                    <div class="userImg"></div>
                </div>
                <div>
                    <div class="userName">{{nickName}}</div>
                    <div class="phoneBox" v-if="companyId!='10015'">
                        <div class="studentNo">{{userPhone}}</div>
                        <div class="span" @click="to(`changePhone`)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabList">
            <div class="tabItem" @click="to(`consult`)">
                <div class="itemIcon m1"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        咨询
                    </div>
                    疏导心结自我和解
                </div>
            </div>
            <div class="tabItem" @click="to('myTest')">
                <div class="itemIcon m2"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        测评
                    </div>
                    认识内心的自我
                </div>
            </div>
            <div class="tabItem" @click="to('myCourse')">
                <div class="itemIcon m3"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        课程
                    </div>
                    查看近期的课程
                </div>
            </div>
            <div class="tabItem" @click="to('myEBook')">
                <div class="itemIcon m6"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        电子书
                    </div>
                    查看近期的电子书
                </div>
            </div>
            <div class="tabItem" @click="to('myCollection')">
                <div class="itemIcon m4"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        收藏
                    </div>
                    文章视频课程测评
                </div>
            </div>
            <div class="tabItem" @click="to(`feedback`)">
                <div class="itemIcon m5"></div>
                <div class="tabWordBox">
                    <div class="tabName">
                        反馈
                    </div>
                    提出建议我们修改
                </div>
            </div>
        </div>

<!--        <div class="loginBtn" @click="signOut" v-if="companyId!='10015'">退 出 登 录</div>-->
        <footerBox active="4"></footerBox>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import footerBox from 'components/footer'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                nickName:localStorage.getItem('nickName')?localStorage.getItem('nickName'):'',
                studentNo:localStorage.getItem('studentNo')?localStorage.getItem('studentNo'):'',
                userPhone:localStorage.getItem('userPhone')?localStorage.getItem('userPhone'):'',
                companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
                count:null,
            }
        },
        components: {
            noMoreData,
            topbar,
            footerBox,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            to(n){
                this.$router.push(n)
            },
            async getNoReadCountForUser() {
                let data = await getSources("/bear-scale/api/systemMessage/getNoReadCountForUser.json", {userId:localStorage.getItem('userId')?localStorage.getItem('userId'):''});
                if (data.status === 0) {
                    this.count = data.count
                }else if(data.status === -1){
                    alert(data.msg)
                    localStorage.clear();
                    if(!localStorage.getItem('userId')){
                        this.$router.push(`/login`)
                    }else{
                        setTimeout(()=>{
                            this.$router.push(`/login`)
                        },200)
                    }
                }else{
                    alert(data.msg)
                }
            },
            signOut(){
                let aa='';
                let bb='';
                if(localStorage.getItem('token')){
                    aa=localStorage.getItem('token')
                }
                if(localStorage.getItem('id')){
                    bb=localStorage.getItem('id')
                }
                localStorage.removeItem('userId')
                // localStorage.removeItem('userId')
                // localStorage.removeItem('nickName')
                if(aa){
                    localStorage.setItem('token',aa)
                }
                if(bb){
                    localStorage.setItem('id',bb)
                }


                if(!localStorage.getItem('userId')){
                    this.$router.push(`/login`)
                }else{
                    setTimeout(()=>{
                        this.$router.push(`/login`)
                    },200)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            if(!localStorage.getItem('userId')){
                if(this.$route.query.code){
                    this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${this.$route.query.code}`)
                }else{
                    this.$router.push(`/login?next=${encodeURIComponent(this.$route.fullPath)}`)
                }
                return
            }
            this.getNoReadCountForUser();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/my.vue?47f7002e